<template>
  <div
    class="wrapper"
    ref="wrapper"
  >
    <slot></slot>
  </div>
</template>

<script>
import BScroll from "better-scroll";

export default {
  props: {
    probeType: {
      type: Number,
      default: 2
    },
    click: {
      type: Boolean,
      default: true
    },
    listenScroll: {
      type: Boolean,
      default: false
    },
    data: {
      type: Array,
      default: null
    },
    pullup: {
      type: Boolean,
      default: true
    },
    beforeScroll: {
      type: Boolean,
      default: false
    },
    refreshDelay: {
      type: Number,
      default: 20
    },
    scrollX: {
      type: Boolean,
      default: false
    }
  },
  mounted () {
    setTimeout(() => {
      this._initScroll();
    }, 20);
  },
  methods: {
    _initScroll () {
      if (!this.$refs.wrapper) {
        return;
      }
      this.scroll = new BScroll(this.$refs.wrapper, {
        probeType: this.probeType,
        click: this.click,
        scrollX: this.scrollX,
        pullDownRefresh: false,
        bounce: false
      });

      if (this.listenScroll) {
        let me = this;
        this.scroll.on("scroll", pos => {
          me.$emit("scroll", pos);
        });
      }

      if (this.pullup) {
        this.scroll.on("scrollEnd", () => {
          this.$emit("scrollToEnd");
        });
      }

      if (this.beforeScroll) {
        this.scroll.on("beforeScrollStart", () => {
          this.$emit("beforeScroll");
        });
      }
    },
    disable () {
      this.scroll && this.scroll.disable();
    },
    enable () {
      this.scroll && this.scroll.enable();
    },
    refresh () {
      this.scroll && this.scroll.refresh();
    },
    scrollTo () {
      this.scroll && this.scroll.scrollTo.apply(this.scroll, arguments);
    },
    scrollToElement () {
      this.scroll && this.scroll.scrollToElement.apply(this.scroll, arguments);
    }
  }
  // watch: {
  //   data() {
  //     setTimeout(() => {
  //       this.refresh();
  //     }, this.refreshDelay);
  //   }
  // }
};
</script>

<style scoped lang="stylus">
.wrapper
  width 100%
  height 100%
  overflow scroll
  position fixed
  top 0
  left 0
  right 0
  bottom 0
  z-index 100
</style>
